import { useEffect, useState } from 'react';
import { db, auth } from './firebase'; // Ensure db is exported from your firebase config
import { 
  collection, 
  query, 
  where, 
  getDocs, 
  addDoc, 
  serverTimestamp, 
  doc, 
  updateDoc 
} from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions'; // For v2 Callables
import {
  getTasks,
  createTask as firebaseCreateTask,
  updateTask as firebaseUpdateTask,
  deleteTask as firebaseDeleteTask
} from './services/tasksService';
import {
  getGroups,
  createGroup as firebaseCreateGroup,
  updateGroup,
  deleteGroupAndTasks
} from './services/groupsService';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

//const API_BASE = 'http://localhost:5000/api';

function Main() {
  const NEON_GREEN = '#00ff88'; // 🌟 Add this line
  const NEON_PURPLE = '#FF3131FF'; // 🌟 Add this line
  const { username } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [tasks, setTasks] = useState([]);
  const [groups, setGroups] = useState([]);
  const initialForm = {
    title: '',
    notes: '',
    importance: 5,
    dueDate: `${new Date().toISOString().split('T')[0]}T23:59`,
    group: '',
    difficulty: '',
    recurrence: {
      type: 'none', // 'none' | 'daily' | 'weekly' | 'monthly'
      days: [],     // for weekly
      date: ''      // for monthly
    }
  };
  const [showMyDayCelebration, setShowMyDayCelebration] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [form, setForm] = useState(initialForm);
  const [sortBy, setSortBy] = useState('newest'); // 'newest' | 'oldest' | 'priority-desc' | 'priority-asc' | 'due-soon' | 'due-late'
  const [easeFilter, setEaseFilter] = useState('all'); // 'all' | 'Easy' | 'Medium' | 'Hard'
  const [completionDateFilter, setCompletionDateFilter] = useState(''); // YYYY-MM-DD
  const [search, setSearch] = useState('');
  const [editingTask, setEditingTask] = useState(null);
  const [hoverRating, setHoverRating] = useState(0);
  const [hasCelebratedToday, setHasCelebratedToday] = useState(false);
  const [remindHours, setRemindHours] = useState(0); // 0 = disabled
  const [filter, setFilter] = useState('all');
  const [newGroup, setNewGroup] = useState('');
  const [editingGroup, setEditingGroup] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [groupToDelete, setGroupToDelete] = useState(null);
  const [groupForm, setGroupForm] = useState({ name: '', notes: '', priority: 5, parentId: null });
  const [statusFilter, setStatusFilter] = useState('all'); // 'all' | 'completed' | 'pending'
  //const [showNotifications, setShowNotifications] = useState(false);
  const [notifiedTasks, setNotifiedTasks] = useState(new Set());

  useEffect(() => {
    // If the logged-in user does not match the URL, redirect to their own page
    console.log('User object:', user);
    console.log('Username from URL:', username);
    if (user && user.name !== username) {
      console.log('Redirecting to:', `/main/${user.name}`);
      navigate(`/main/${user.name}`, { replace: true });
    }
    // eslint-disable-next-line
  }, [user, username, navigate]);

  
  useEffect(() => {
    if (user) {
    fetchAll();
  }
    // Check for due tasks every minute
    const interval = setInterval(checkDueTasks, 60000);
    
    // Request notification permission on component mount
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
         // setShowNotifications(true);
        }
      });
    }
    
    return () => clearInterval(interval);
  }, []);
 useEffect(() => {
  const todayStr = new Date().toLocaleDateString();

  const myDayTasks = tasks.filter(task => {
    if (!task.dueDate) return false;
    return new Date(task.dueDate).toLocaleDateString() === todayStr;
  });

  const hasTasksToday = myDayTasks.length > 0;
  const allCompleted = myDayTasks.every(task => task.completed);

  if (hasTasksToday && allCompleted) {
    // 🎯 Trigger celebration only if it hasn't happened yet
    if (!hasCelebratedToday) {
      setShowMyDayCelebration(true);
      setHasCelebratedToday(true);
      
      // Auto-hide after 5 seconds
      const timer = setTimeout(() => setShowMyDayCelebration(false), 5000);
      return () => clearTimeout(timer);
    }
  } else {
    // 🎯 FIX: If the user unchecks a task, reset the flag
    // This allows the toast to trigger again when they re-check it
    if (hasCelebratedToday) {
      setHasCelebratedToday(false);
      setShowMyDayCelebration(false); // Hide the toast immediately if it was visible
    }
  }
}, [tasks, hasCelebratedToday]);
  const getDifficultyStyle = (difficulty) => {
  switch (difficulty) {
    case 'Easy': return { color: '#FFD700', bg: 'rgba(255, 215, 0, 0.1)', border: '#FFD700' }; // Yellow
    case 'Medium': return { color: '#ff9800', bg: 'rgba(255, 152, 0, 0.1)', border: '#ff9800' }; // Orange
    case 'Hard': return { color: '#ef4444', bg: 'rgba(239, 68, 68, 0.1)', border: '#ef4444' }; // Red
    default: return null;
  }
};
const buildGroupTree = (flatGroups) => {
  const map = {};
  const tree = [];

  flatGroups.forEach(group => {
    map[group.id] = { ...group, children: [] };
  });

  flatGroups.forEach(group => {
    if (group.parentId && map[group.parentId]) {
      map[group.parentId].children.push(map[group.id]);
    } else {
      tree.push(map[group.id]);
    }
  });

  return tree;
};
// 🌟 Add this helper to convert any date format to HTML input format
const formatForInput = (dateValue) => {
  if (!dateValue) return "";
  // If it's a Firestore Timestamp, convert to Date; otherwise use as is
  const date = dateValue.toDate ? dateValue.toDate() : new Date(dateValue);
  if (isNaN(date.getTime())) return "";
  
  const pad = (n) => n.toString().padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
const groupTree = buildGroupTree(groups);
  const checkDueTasks = () => {
    const now = new Date();
    const sixHoursFromNow = new Date(now.getTime() + 6 * 60 * 60 * 1000);
    
    const dueSoonTasks = tasks.filter(task => {
      if (task.completed || !task.dueDate) return false;
      const dueDate = new Date(task.dueDate);
      return dueDate <= sixHoursFromNow && dueDate > now && !notifiedTasks.has(task.id);
    });

    dueSoonTasks.forEach(task => {
      //sendNotification(task);
      setNotifiedTasks(prev => new Set([...prev, task.id]));
    });
  };
  const renderGroup = (group, level = 0) => {
  return (
    <div key={group.id} className="group-branch">
      <div 
        className="group-item-container" 
        style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          paddingLeft: `${level * 15}px` // 🌟 Indent subgroups
        }}
      >
       <div className="group-item-wrapper" style={{ flex: 1, position: 'relative' }}>
  <button 
    onClick={() => {
      setFilter(group.name);
      setForm(prev => ({ ...prev, group: group.name }));
    }} 
    className={getFilterButtonClass(group.name)}
    style={{ width: '100%', textAlign: 'left' }}
  >
    <span className="group-icon">{level > 0 ? '└' : '#'}</span>
    <span>{group.name}</span>
  </button>

  {/* 🌟 Tooltip that appears on hover */}
  {(group.notes || group.priority) && (
    <div className="group-tooltip">
      {group.priority && (
        <div style={{ marginBottom: '5px', borderBottom: '1px solid #333', pb: '5px' }}>
          {renderStars(group.priority)}
        </div>
      )}
      {group.notes && <p style={{ margin: 0, fontSize: '0.75rem', lineHeight: '1.3' }}>{group.notes}</p>}
    </div>
  )}
</div>
        
        <div className="group-actions" style={{ display: 'flex', gap: '5px' }}>
          {/* 🌟 Plus button to quickly add a subgroup */}
          <button onClick={() => {
            setEditingGroup(null);
            setGroupForm({ name: '', notes: '', priority: 5, parentId: group.id });
          }} title="Add Subgroup">➕</button>
          
          <button onClick={() => {
            setEditingGroup(group);
            setGroupForm({ name: group.name, notes: group.notes || '', priority: group.priority || 5, parentId: group.parentId });
          }}>✏️</button>
          
          <button onClick={() => openDeleteModal(group.id, group.name)}>🗑️</button>
        </div>
      </div>
      
      {/* 🌟 Recurse for children */}
      {group.children && group.children.map(child => renderGroup(child, level + 1))}
    </div>
  );
};

  //const sendNotification = async (task) => {
    // Web notification
   // if ('Notification' in window && Notification.permission === 'granted') {
      //new Notification('Task Due Soon!', {
       // body: `${task.title} is due in less than 6 hours. Finish it fast!`,
       // icon: '/favicon.ico',
       // badge: '/favicon.ico'
      //});
    //}

    // Email notification (you'll need to implement this on backend)
    //try {
     // await axios.post(`${API_BASE}/notifications/email`, {
        //taskId: task.id,
        //taskTitle: task.title,
        //dueDate: task.dueDate
    //  }, { withCredentials: true });
    //} catch (error) {
      //console.error('Failed to send email notification:', error);
    //}
 // };

  const requestNotificationPermission = () => {
    if ('Notification' in window) {
      Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          //setShowNotifications(true);
        }
      });
    }
  };
  const handleGroupSubmit = async (e, forceCreate = false) => {
  if (e) e.preventDefault();
  const trimmedName = groupForm.name.trim();
  if (!trimmedName) return;

  // 🌟 CHECK FOR DUPLICATES (Only if not already editing the same group)
  const isDuplicate = groups.some(g => 
    g.name.toLowerCase() === trimmedName.toLowerCase() && 
    (!editingGroup || g.id !== editingGroup.id)
  );

  if (isDuplicate && !forceCreate) {
    setShowDuplicateModal(true); // Open the elegant popup instead of creating
    return;
  }

  try {
    if (editingGroup) {
      await updateGroup(editingGroup.id, editingGroup.name, groupForm);
    } else {
      await firebaseCreateGroup(groupForm);
    }
    resetGroupForm();
    fetchAll();
  } catch (err) {
    alert(err.message);
  }
};

const resetGroupForm = () => {
  setEditingGroup(null);
  setGroupForm({ name: '', notes: '', priority: 5, parentId: null });
  setShowDuplicateModal(false);
};

const openDeleteModal = (groupId, groupName) => {
  setGroupToDelete({ id: groupId, name: groupName });
  setShowDeleteModal(true);
};

const confirmDeletion = async () => {
  if (!groupToDelete) return;
  
  try {
    await deleteGroupAndTasks(groupToDelete.id, groupToDelete.name);
    if (filter === groupToDelete.name) setFilter('all');
    fetchAll();
    setShowDeleteModal(false);
    setGroupToDelete(null);
  } catch (err) {
    alert(err.message);
  }
};


const fetchAll = async () => {
  try {
    const user = auth.currentUser;
    if (!user) return;

    // 🌟 Strictly personal: only fetch tasks where spaceId is null/undefined
    const [taskData, groupData] = await Promise.all([
      getTasks(), // Ensure your service filters by spaceId: null if possible
      getGroups()
    ]);

    setTasks(taskData);
    setGroups(groupData);
  } catch (err) {
    console.error('❌ Personal Fetch Error:', err);
  }
};

/* REPLACE THE ENTIRE handleFormSubmit FUNCTION */
const handleFormSubmit = async (e) => {
  e.preventDefault();
  if (!form.title.trim()) return;

  // 🌟 Logic: Ensure userId is never undefined to prevent the Firebase Error
  const currentUserId = user?.uid || auth.currentUser?.uid;
  if (!currentUserId) {
    alert("Authentication error. Please log in again.");
    return;
  }

  const payload = {
    ...form,
    spaceId: null,
    userId: currentUserId, // 🌟 Guaranteed string instead of undefined
    updatedAt: serverTimestamp(),
    recurrence: {
      type: form.recurrence.type,
      days: form.recurrence.type === 'weekly' ? form.recurrence.days : [],
      date: form.recurrence.type === 'monthly' ? form.recurrence.date : null
    },
    completed: editingTask ? form.completed : false,
    recurrenceProcessed: false,
  };

  // Clean payload: Remove any accidentally undefined fields
  Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

  try {
    if (editingTask) {
      await updateTask(editingTask.id, payload);
    } else {
      await createTask(payload);
    }
    const currentGroup = form.group;
    resetForm();
     // Re-apply the group to the form immediately
    if (currentGroup) {
      setForm(prev => ({ ...prev, group: currentGroup }));
    }
  } catch (err) {
    console.error("Submit Error:", err);
    alert("Failed to save task: " + err.message);
  }
};

  const createTask = async (payload) => {
  await firebaseCreateTask(payload);
  await fetchAll();
};

  const updateTask = async (id, data) => {
  await firebaseUpdateTask(id, data);
  await fetchAll();
};


  const deleteTask = async (id) => {
  if (window.confirm('Are you sure?')) {
    await firebaseDeleteTask(id);
    await fetchAll();
  }
};

  
  const resetForm = () => {
    setEditingTask(null);
    setForm(initialForm);
  };

const handleEdit = (task) => {
  setEditingTask(task);
  
  let formattedDate = '';
  if (task.dueDate) {
    // 🌟 Robust datetime-local formatting
    const d = new Date(task.dueDate);
    const pad = (num) => num.toString().padStart(2, '0');
    formattedDate = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  setForm({
    title: task.title || '',
    notes: task.notes || '',
    importance: task.importance || 5,
    dueDate: formattedDate,
    completed: task.completed || false,
    group: task.group || '',
    difficulty: task.difficulty || '',
    recurrence: task.recurrence || { type: 'none', days: [], date: '' }
  });
};
  // --- Add this in the logic section of Main.js ---

{/*const saveNotificationPreference = async () => {
  if (!user) return; // Safety check
  
  try {
    // We import 'doc' and 'setDoc' from 'firebase/firestore'
    // Ensure 'db' is imported from your firebase.js config
    const userRef = doc(db, "users", user.uid);
    
    await setDoc(userRef, { 
      remindHoursBefore: remindHours,
      email: user.email, // Important for the Cloud Function to know where to send mail
      updatedAt: new Date()
    }, { merge: true });

    alert("Notification preferences saved!");
  } catch (error) {
    console.error("Error saving notification preference:", error);
    alert("Failed to save preference.");
  }
}; */}
  
  const handleNewGroup = async () => {
    if (!newGroup.trim()) return;
    try {
      await firebaseCreateGroup(newGroup.trim());

      setNewGroup('');
      await fetchAll();
    } catch (error) {
      console.error('Group creation error:', error);
      const errorMessage = error.response?.data?.error || error.message || 'Failed to create group.';
      alert(errorMessage);
    }
  };

  const getFilterButtonClass = (filterName) => {
    return filter === filterName 
      ? "filter-btn filter-btn-active" 
      : "filter-btn filter-btn-inactive";
  };
  
  const renderStars = (rating, isForm = false, onRatingChange = null) => {
    const currentRating = isForm ? rating : rating;
    
    return Array.from({ length: 10 }, (_, i) => i + 1).map((i) => (
      <span
        key={i}
        className={`star-neon cursor-pointer text-lg transition-all duration-200 ${
          i <= (hoverRating || currentRating) ? 'text-neon-green' : 'text-gray-500'
        } hover:scale-110`}
        onMouseEnter={() => setHoverRating(i)}
        onMouseLeave={() => setHoverRating(0)}
        onClick={() => {
          if (onRatingChange) onRatingChange(i);
          if (isForm) setForm({ ...form, importance: i });
        }}
      >
        ★
      </span>
    ));
  };
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);
const clearAllFilters = () => {
  setSearch('');
  setSortBy('newest');
  setEaseFilter('all');
  setStatusFilter('all');
  setCompletionDateFilter('');
  // Note: We don't reset 'filter' (Sidebar) because that defines the current view/context
};
  const filteredTasks = tasks
    .filter((task) => {
     if (task.spaceId) return false;
      // 1. Sidebar/Quick Filters
      switch (filter) {
        case 'myday': {
  if (!task.dueDate) return false;
  
  const now = new Date();
  const taskDue = new Date(task.dueDate);
  
  // 🌟 Strict IST Check: Matches ONLY the current calendar day
  return (
    taskDue.getDate() === now.getDate() &&
    taskDue.getMonth() === now.getMonth() &&
    taskDue.getFullYear() === now.getFullYear()
  );
}
        case 'important':
          return task.importance >= 7;
        case 'upcoming':
          if (task.completed || !task.dueDate) return false;
          return new Date(task.dueDate) > today;
        case 'all':
          return true;
        default:
          return task.group === filter;
      }
    })
    .filter((task) => {
      // 2. Text Search (Title & Notes)
      const searchMatch = task.title.toLowerCase().includes(search.toLowerCase()) || 
                          (task.notes && task.notes.toLowerCase().includes(search.toLowerCase()));
      
      // 3. Ease/Difficulty Filter
      const easeMatch = easeFilter === 'all' || task.difficulty === easeFilter
      
      // 4. Completion Date Filter
      let dateMatch = true;
      if (completionDateFilter) {
        if (!task.completed || !task.completedAt) {
          dateMatch = false;
        } else {
          const compDate = new Date(task.completedAt).toISOString().split('T')[0];
          dateMatch = compDate === completionDateFilter;
        }
      }
// ... inside .filter((task) => { ...
const isOverdue = !task.completed && task.dueDate && new Date(task.dueDate) < today;

const statusMatch = statusFilter === 'all' || 
                   (statusFilter === 'completed' ? task.completed : 
                    statusFilter === 'pending' ? !task.completed :
                    statusFilter === 'overdue' ? isOverdue : true);

return searchMatch && easeMatch && dateMatch && statusMatch; // 🌟 Include statusMatch here
    })
    .sort((a, b) => {
       // 🌟 Primary Sort: Pending (false) comes before Completed (true)
  if (a.completed !== b.completed) {
    return a.completed ? 1 : -1; 
  }

  // 🌟 Secondary Sort: Apply the user's selected sortBy preference
      // 5. Advanced Sorting
      switch (sortBy) {
        case 'priority-desc': return b.importance - a.importance;
        case 'priority-asc': return a.importance - b.importance;
        case 'status-done': return (a.completed === b.completed) ? 0 : a.completed ? -1 : 1; // Completed first
        case 'status-todo': return (a.completed === b.completed) ? 0 : a.completed ? 1 : -1; // Yet to do first
        case 'due-soon':
          return (a.dueDate ? new Date(a.dueDate) : new Date('9999')) - (b.dueDate ? new Date(b.dueDate) : new Date('9999'));
        case 'due-late':
          return (b.dueDate ? new Date(b.dueDate) : new Date('0000')) - (a.dueDate ? new Date(a.dueDate) : new Date('0000'));
        case 'oldest': return new Date(a.createdAt) - new Date(b.createdAt);
        case 'newest':
        default: return new Date(b.createdAt) - new Date(a.createdAt);
      }
    });
  const getTaskPriorityColor = (importance) => {
    if (importance >= 8) return 'task-card-priority-high';
    if (importance >= 6) return 'task-card-priority-medium';
    return 'task-card-priority-low';
  };

 const getDueDateStatus = (dueDate) => {
  if (!dueDate) return { text: 'No due date', color: 'text-gray-400' };
  
  const now = new Date();
  const due = new Date(dueDate);
  
  // Calculate difference in milliseconds
  const diffMs = due - now;
  const diffHrs = diffMs / (1000 * 60 * 60);
  const diffDays = Math.floor(diffHrs / 24);

  // 1. Overdue Logic
  if (diffMs < 0) {
    return { text: 'Overdue', color: 'text-red-400' };
  }

  // 2. "Due Today" with Countdown (If less than 24 hours away)
  if (diffHrs > 0 && diffHrs < 24) {
    const hours = Math.floor(diffHrs);
    const minutes = Math.round((diffHrs - hours) * 60);
    
    // If it's less than 1 hour, show minutes only
    if (hours === 0) return { text: `Due in ${minutes}m`, color: 'text-orange-400' };
    return { text: `Due in ${hours}h ${minutes}m`, color: 'text-orange-400' };
  }

  // 3. "Due Tomorrow" Logic (Specifically for the next calendar day)
  const tomorrow = new Date();
  tomorrow.setDate(now.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);
  
  const isTomorrow = due.toDateString() === tomorrow.toDateString();
  if (isTomorrow) {
    return { text: 'Due tomorrow', color: 'text-yellow-400' };
  }

  // 4. Future Tasks
  if (diffDays <= 3) return { text: `Due in ${diffDays} days`, color: 'text-neon-green' };
  
  return { text: `Due ${due.toLocaleDateString('en-IN')}`, color: 'text-gray-400' };
};

  return (
    <div className="main-container-neon">
      {/* Sidebar */}
      <aside className="sidebar-neon">
        <div className="sidebar-header">
          <h2 className="welcome-text">Welcome back, {user?.name}!</h2>
          <p className="welcome-subtitle">Let's get things done today</p>
          <div className="stats-container">
            <div className="stat-item">
              <span className="stat-label">Total Tasks</span>
              <span className="stat-value">{tasks.length}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Completed</span>
              <span className="stat-value stat-completed">{tasks.filter(t => t.completed).length}</span>
            </div>
            <div className="stat-item">
              <span className="stat-label">Pending</span>
              <span className="stat-value stat-pending">{tasks.filter(t => !t.completed).length}</span>
            </div>
          </div>
        </div>
        {/*<div className="notifications-preference" style={{ padding: '15px', borderBottom: '1px solid #222' }}>
  <h3 className="section-title">Email Reminders</h3>
  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
    <input 
      type="number" 
      className="group-input" 
      style={{ width: '60px' }}
      value={remindHours}
      onChange={(e) => setRemindHours(parseInt(e.target.value))}
      placeholder="Hrs"
    />
    <span style={{ fontSize: '0.8rem', color: '#aaa' }}>hours before</span>
  </div>
  <button 
    onClick={saveNotificationPreference} // We will define this function
    className="submit-btn" 
    style={{ marginTop: '10px', fontSize: '0.7rem', padding: '5px' }}
  >
    Save Preference
  </button>
</div>*/}

        <div className="filters-section">
          <h5 className="section-title">Quick Filters</h5>
          <div className="filters-grid">
            <button 
  onClick={() => {
    setFilter('all');
    setForm(prev => ({ ...prev, group: '' })); // Clear auto-group
  }} 
  className={getFilterButtonClass('all')}
>
  <span className="filter-icon">📋</span>
  <span>All Tasks</span>
</button>
            <button 
  onClick={() => {
    setFilter('myday');
    const todayStr = new Date().toISOString().split('T')[0];
    setForm(prev => ({ ...prev, group: '', dueDate: todayStr })); 
  }} 
  className={getFilterButtonClass('myday')}
>
  <span className="filter-icon">🌞</span>
  <span>My Day</span>
</button>
            <button onClick={() => setFilter('important')} className={getFilterButtonClass('important')}>
              <span className="filter-icon">❗</span>
              <span>Important</span>
            </button>
            <button onClick={() => setFilter('upcoming')} className={getFilterButtonClass('upcoming')}>
              <span className="filter-icon">📅</span>
              <span>Upcoming</span>
            </button>
          </div>
        </div>

       <div className="groups-section">
  <h3 className="section-title">Groups & Subgroups</h3>
  
  <div className="groups-list" style={{ marginBottom: '15px' }}>
    {groupTree.map((rootGroup) => renderGroup(rootGroup))}
  </div>

  {/* New/Edit Group Form */}
  <form onSubmit={handleGroupSubmit} className="new-group-form" style={{ flexDirection: 'column', gap: '8px', padding: '10px', background: 'rgba(255,255,255,0.03)', borderRadius: '8px' }}>
    
    {/* 🌟 Helper text showing WHERE the new subgroup is going */}
    {groupForm.parentId && !editingGroup && (
      <div style={{ fontSize: '0.7rem', color: NEON_GREEN, display: 'flex', justifyContent: 'space-between' }}>
        <span>Adding subgroup to: <b>{groups.find(g => g.id === groupForm.parentId)?.name}</b></span>
        <button type="button" onClick={() => setGroupForm({...groupForm, parentId: null})} style={{ color: '#ef4444', background: 'none', border: 'none', cursor: 'pointer' }}>Cancel</button>
      </div>
    )}

    <input
      className="group-input"
      placeholder={groupForm.parentId ? "Subgroup name..." : "Group name..."}
      value={groupForm.name}
      onChange={(e) => setGroupForm({ ...groupForm, name: e.target.value })}
    />

    {(editingGroup || groupForm.name.length > 0) && (
      <>
        <textarea 
          placeholder="Optional notes..." 
          className="task-notes-input"
          style={{ fontSize: '0.8rem', minHeight: '40px' }}
          value={groupForm.notes}
          onChange={(e) => setGroupForm({ ...groupForm, notes: e.target.value })}
        />
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ fontSize: '0.75rem', color: '#aaa' }}>Priority:</span>
          <div style={{ transform: 'scale(0.8)', transformOrigin: 'left' }}>
            {renderStars(groupForm.priority, false, (val) => setGroupForm({...groupForm, priority: val}))}
          </div>
        </div>
      </>
    )}

    <div style={{ display: 'flex', gap: '5px' }}>
      <button type="submit" className="add-group-btn" style={{ flex: 1, padding: '8px' }}>
        {editingGroup ? 'Update' : groupForm.parentId ? 'Add Subgroup' : 'Add Group'}
      </button>
      {(editingGroup || groupForm.parentId) && (
        <button 
          type="button"
          onClick={() => {
            setEditingGroup(null);
            setGroupForm({ name: '', notes: '', priority: 5, parentId: null });
          }} 
          className="cancel-btn"
          style={{ padding: '8px' }}
        >
          Cancel
        </button>
      )}
    </div>
  </form>
</div>

        {/* Notification Settings */}
        {/*}
        <div className="notifications-section">
          <h3 className="section-title">Notifications</h3>
          {Notification.permission === 'granted' ? (
            <div className="notification-status notification-enabled">
              <div className="status-icon">✅</div>
              <div className="status-content">
                <span className="status-title">Notifications Enabled</span>
                <span className="status-desc">You'll receive alerts for tasks due within 6 hours</span>
              </div>
            </div>
          ) : Notification.permission === 'denied' ? (
            <div className="notification-status notification-blocked">
              <div className="status-icon">❌</div>
              <div className="status-content">
                <span className="status-title">Notifications Blocked</span>
                <span className="status-desc">Please enable notifications in your browser settings</span>
              </div>
            </div>
          ) : (
            <button 
              onClick={requestNotificationPermission}
              className="enable-notifications-btn"
            >
              Enable Notifications
            </button>
          )}
        </div>*/}
      </aside>

      {/* Main content */}
      <main className="main-content-neon">
        <div className="content-wrapper">
          <div className="page-header">
            <h1 className="page-title">
              {filter === 'all' ? 'All Tasks' : 
               filter === 'upcoming' ? 'Upcoming Tasks' : 
               filter === 'myday' ? 'My Day' : 
               filter === 'important' ? 'Important Tasks' : 
               `#${filter}`}
            </h1>
        {/* 🌟 New: Display Active Group Metadata */}
  {groups.find(g => g.name === filter) && (
    <div className="active-group-meta" style={{ marginTop: '10px' }}>
      {/* Show Stars for Group Priority */}
      <div style={{ marginBottom: '5px' }}>
        {renderStars(groups.find(g => g.name === filter).priority)}
      </div>
      
      {/* Show Group Notes */}
      {groups.find(g => g.name === filter).notes && (
        <p style={{ 
          color: '#aaa', 
          fontSize: '0.9rem', 
          fontStyle: 'italic', 
          margin: '5px 0',
          maxWidth: '600px'
        }}>
          "{groups.find(g => g.name === filter).notes}"
        </p>
      )}
    </div>
  )}
            <p className="page-subtitle">
              {filteredTasks.length} {filteredTasks.length === 1 ? 'task' : 'tasks'}
            </p>
          </div>

          {/* Task Form */}
          <div className="task-form-container">
            <form onSubmit={handleFormSubmit}>
              <div className="form-header">
                <input
                  className="task-input"
                  placeholder="What's on your mind?"
                  value={form.title}
                  onChange={(e) => setForm({ ...form, title: e.target.value })}
                />
                <textarea
  className="task-notes-input"
  placeholder="Add a short description or notes (optional)..."
  value={form.notes}
  maxLength={250} // 🌟 Limits input to 250 characters
  onChange={(e) => setForm({ ...form, notes: e.target.value })}
  style={{ 
    width: '100%', 
    background: 'transparent', 
    border: 'none', 
    borderBottom: '1px solid #333', 
    color: 'white', 
    marginTop: '8px',
    padding: '4px',
    fontSize: '0.9rem',
    outline: 'none',
    resize: 'none' // Prevents user from manually stretching the box
  }}
/>
{/* Optional: Add a counter so users know their limit */}
<small style={{ color: '#666', fontSize: '0.7rem' }}>
  {form.notes.length}/250
</small>
                <button 
                  type="submit" 
                  className="submit-btn"
                >
                  {editingTask ? 'Save Changes' : 'Add Task'}
                </button>
                {editingTask && (
                  <button 
                    type="button" 
                    onClick={resetForm} 
                    className="cancel-btn"
                  >
                    Cancel
                  </button>
                )}
              </div>
              
              <div className="form-options">
                <div className="option-group">
                  <span className="option-label">Priority:</span>
                  <div className="stars-container">
                    {renderStars(form.importance, true)}
                  </div>
                  <div className="option-group">
  <span className="option-label">Ease:</span>
  <select
    className="group-select"
    value={form.difficulty}
    onChange={(e) => setForm({ ...form, difficulty: e.target.value })}
    style={{ color: getDifficultyStyle(form.difficulty)?.color || 'white' }}
  >
    <option value="">None</option>
    <option value="Easy" style={{ color: '#FFD700' }}>Easy</option>
    <option value="Medium" style={{ color: '#ff9800' }}>Medium</option>
    <option value="Hard" style={{ color: '#ef4444' }}>Hard</option>
  </select>
</div>
                </div>
<div className="option-group">
  <span className="option-label">Due Date & Time:</span>
  <input
    className="date-input"
    type="datetime-local" 
    value={formatForInput(form.dueDate)} // 🌟 Changed to use helper
    onChange={(e) => setForm({ ...form, dueDate: e.target.value })}
    onFocus={(e) => {
      if (!form.dueDate) {
        const todayStr = new Date().toISOString().split('T')[0];
        setForm({ ...form, dueDate: `${todayStr}T23:59` });
      }
    }}
  />
</div>
                <div className="option-group">
                  <span className="option-label">Group:</span>
                  <select
                    className="group-select"
                    value={form.group}
                    onChange={(e) => setForm({ ...form, group: e.target.value })}
                  >
                    <option value="">No Group</option>
                    {groups.map((g) => <option key={g.id} value={g.name}>{g.name}</option>)}
                  </select>
                </div>
                {/* Add this inside your <form> after the Group select */}


                <div className="option-group">
                  <span className="option-label">Repeat:</span>
                  <select
                    className="group-select"
                    value={form.recurrence.type}
                    onChange={e => setForm({
                      ...form,
                      recurrence: { type: e.target.value, days: [], date: '' }
                    })}
                  >
                    <option value="none">None</option>
                    <option value="daily">Every day</option>
                    <option value="weekly">Specific days</option>
                    <option value="monthly">Every Nth of month</option>
                  </select>
                </div>
                {form.recurrence.type === 'weekly' && (
                  <div className="option-group">
                    <span className="option-label">Days:</span>
                    <div style={{ display: 'flex', gap: 8 }}>
                      {["Sun","Mon","Tue","Wed","Thu","Fri","Sat"].map((d, i) => (
                        <label key={i} style={{ color: form.recurrence.days.includes(i) ? 'var(--neon-green)' : 'var(--text-secondary)', fontWeight: 600 }}>
                          <input
                            type="checkbox"
                            checked={form.recurrence.days.includes(i)}
                            onChange={e => {
                              const days = form.recurrence.days.includes(i)
                                ? form.recurrence.days.filter(x => x !== i)
                                : [...form.recurrence.days, i];
                              setForm({ ...form, recurrence: { ...form.recurrence, days } });
                            }}
                            style={{ marginRight: 4 }}
                          />
                          {d}
                        </label>
                      ))}
                    </div>
                  </div>
                )}
                {form.recurrence.type === 'monthly' && (
                  <div className="option-group">
                    <span className="option-label">Date:</span>
                    <input
                      className="date-input"
                      type="number"
                      min="1"
                      max="31"
                      value={form.recurrence.date}
                      onChange={e => setForm({ ...form, recurrence: { ...form.recurrence, date: e.target.value } })}
                      placeholder="e.g. 6 for every 6th"
                      style={{ width: 100 }}
                    />
                  </div>
                )}
              </div>
            </form>
          </div>

          {/* Search */}
          <div className="search-container" style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
    <div className="search-wrapper">
      <input
        className="search-input"
        placeholder="Search title or notes..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <span className="search-icon">🔍</span>
    </div>

    {/* 🌟 New Advanced Filter UI Row */}
    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
  
  {/* Status Filter - Updated with Overdue */}
  <select 
    className="group-select" 
    value={statusFilter} 
    onChange={(e) => setStatusFilter(e.target.value)}
    style={{ borderColor: statusFilter === 'overdue' ? '#ef4444' : '' }}
  >
    <option value="all">All Status</option>
    <option value="pending">Yet to Do</option>
    <option value="completed">Completed</option>
    <option value="overdue">Overdue</option>
  </select>

  {/* Ease Filter */}
  <select 
    className="group-select" 
    value={easeFilter} 
    onChange={(e) => setEaseFilter(e.target.value)}
  >
    <option value="all">All Difficulty</option>
    <option value="Easy">Easy Only</option>
    <option value="Medium">Medium Only</option>
    <option value="Hard">Hard Only</option>
  </select>

  {/* Sort By */}
  <select 
    className="group-select" 
    value={sortBy} 
    onChange={(e) => setSortBy(e.target.value)}
  >
    <option value="newest">Newest First</option>
    <option value="oldest">Oldest First</option>
    <option value="priority-desc">Highest Priority</option>
    <option value="priority-asc">Lowest Priority</option>
    <option value="due-soon">Due Date: Soonest</option>
    <option value="due-late">Due Date: Latest</option>
    <option value="status-todo">Status: Yet to Do First</option>
    <option value="status-done">Status: Completed First</option>
  </select>

  {/* Completion Date Picker */}
  <p> Completed on: </p>
  <input 
    type="date" 
    className="date-input" 
    value={completionDateFilter} 
    onChange={(e) => setCompletionDateFilter(e.target.value)}
  />

  {/* 🌟 Clear All Button */}
  {(search || easeFilter !== 'all' || statusFilter !== 'all' || completionDateFilter || sortBy !== 'newest') && (
    <button 
      onClick={clearAllFilters}
      className="cancel-btn"
      style={{ 
        padding: '5px 15px', 
        fontSize: '0.8rem', 
        height: '35px',
        border: '1px solid #ef4444',
        color: '#ef4444'
      }}
    >
      Clear All
    </button>
  )}
</div>
  </div>

          {/* Task List */}
          <div className="tasks-container">
            {filteredTasks.map((task) => {
              const dueStatus = getDueDateStatus(task.dueDate);
              return (
                <div 
                  key={task.id} 
                  className={`task-card ${getTaskPriorityColor(task.importance)}`}
                >
                  <div className="task-content">
                    <div className="task-main">
                      <input
                        type="checkbox"
                        className="task-checkbox"
                        checked={task.completed}
                        onChange={() => updateTask(task.id, { completed: !task.completed })}
                      />
                      
                      <div className="task-details">
                        <h3 className={`task-title ${task.completed ? 'task-completed' : ''}`}>
                          {task.title}
                        </h3>
                        {/* 🌟 Display notes if they exist */}
 {task.notes && (
  <p 
    className="task-notes-display" 
    style={{ 
      color: '#aaa', 
      fontSize: '0.85rem', 
      margin: '4px 0',
      lineHeight: '1.4',
      // 🌟 CRITICAL OVERFLOW FIXES:
      wordBreak: 'break-word', // Breaks long words like the "liuuujigg..." in your screenshot
      overflowWrap: 'anywhere', // Ensures text stays inside the card
      display: '-webkit-box',
      WebkitLineClamp: 3, // Limits display to 3 lines (adds "..." if longer)
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden'
    }}
  >
    {task.notes}
  </p>
)}
                        <div className="task-meta">
                          <span className={`due-status ${dueStatus.color}`}>{dueStatus.text}</span>
                          {task.group && (
                            <span className="group-badge">
                              #{task.group}
                            </span>
                          )}
                          {/* 🌟 LeetCode-style Difficulty Tag */}
  {task.difficulty && (
    <span 
      className="difficulty-tag"
      style={{
        padding: '2px 8px',
        borderRadius: '4px',
        fontSize: '0.75rem',
        fontWeight: '600',
        marginLeft: '8px',
        border: `1px solid ${getDifficultyStyle(task.difficulty).border}`,
        color: getDifficultyStyle(task.difficulty).color,
        backgroundColor: getDifficultyStyle(task.difficulty).bg,
        textTransform: 'uppercase'
      }}
    >
      {task.difficulty}
    </span>
  )}
                          <div className="priority-stars">
                            {renderStars(task.importance)}
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="task-actions">
                      <button 
                        className="action-btn edit-btn"
                        onClick={() => handleEdit(task)}
                      >
                        ✏️
                      </button>
                      <button 
                        className="action-btn delete-btn"
                        onClick={() => deleteTask(task.id)}
                      >
                        🗑️
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
            
            {filteredTasks.length === 0 && (
              <div className="empty-state">
                <div className="empty-icon">📝</div>
                <h3 className="empty-title">No tasks found</h3>
                <p className="empty-desc">Create your first task to get started!</p>
              </div>
            )}
          </div>
        </div>
      </main>
      {/* 🎉 My Day Completion Celebration Toast */}
{showMyDayCelebration && (
  <div className="celebration-toast-neon">
    <div className="toast-icon">🌟</div>
    <div className="toast-content">
      <h4 style={{ margin: 0, color: NEON_GREEN }}>Hurray!</h4>
      <p style={{ margin: 0, fontSize: '0.8rem', color: '#ccc' }}>
        You have completed all tasks for the day! Keep up the good work.
      </p>
    </div>
    <button 
      className="close-toast" 
      onClick={() => setShowMyDayCelebration(false)}
    >
      ×
    </button>
  </div>
)}<style>{`
  .celebration-toast-neon {
    position: fixed;
    bottom: 30px;
    right: 30px;
    background: #0a0a0a;
    border: 1px solid #00ff88;
    box-shadow: 0 0 15px rgba(0, 255, 136, 0.2);
    border-radius: 12px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    z-index: 9999;
    min-width: 300px;
    animation: slideInRight 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }

  @keyframes slideInRight {
    from { transform: translateX(120%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }

  .toast-icon {
    font-size: 2rem;
    filter: drop-shadow(0 0 5px #00ff88);
  }

  .close-toast {
    background: none;
    border: none;
    color: #555;
    font-size: 1.5rem;
    cursor: pointer;
    margin-left: auto;
    transition: color 0.2s;
  }

  .close-toast:hover {
    color: #ef4444;
  }
`}</style>
      {/* 💎 Neon Duplicate Name Warning Modal */}
{showDuplicateModal && (
  <div className="modal-overlay">
    <div className="neon-modal" style={{ borderColor: NEON_PURPLE, boxShadow: `0 0 20px ${NEON_PURPLE}44` }}>
      <div className="modal-header">
        <h2 style={{ color: NEON_PURPLE, margin: 0 }}>Duplicate Name</h2>
      </div>
      <div className="modal-body" style={{ marginTop: '15px' }}>
        <p style={{ color: '#ccc', lineHeight: '1.5' }}>
          A group named <b style={{ color: '#fff' }}>"{groupForm.name}"</b> already exists.
          <br /><br />
          <span style={{ color: NEON_PURPLE }}>Creating a duplicate will link tasks by name. Deleting one might affect the other.</span>
        </p>
      </div>
      <div className="modal-actions" style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
        <button 
          className="submit-btn" 
          style={{ background: '#333', border: '1px solid #444', flex: 1 }}
          onClick={() => setShowDuplicateModal(false)}
        >
          Change Name
        </button>
        <button 
          className="submit-btn" 
          style={{ background: 'rgba(139, 92, 246, 0.2)', border: `1px solid ${NEON_PURPLE}`, color: NEON_PURPLE, flex: 1 }}
          onClick={() => handleGroupSubmit(null, true)} // 🌟 Force creation
        >
          Create Anyway
        </button>
      </div>
    </div>
  </div>
)}
      {/* 🚨 Neon Custom Delete Modal */}
{showDeleteModal && (
  <div className="modal-overlay">
    <div className="neon-modal">
      <div className="modal-header">
        <h2 style={{ color: '#ef4444', margin: 0 }}>⚠️ Delete Group?</h2>
      </div>
      <div className="modal-body">
        <p style={{ color: '#ccc', lineHeight: '1.5' }}>
          Are you sure you want to delete <b style={{ color: '#fff' }}>"{groupToDelete?.name}"</b>?
          <br />
          <span style={{ color: '#ef4444', fontSize: '0.85rem' }}>
            Warning: All tasks inside this group will be permanently removed.
          </span>
        </p>
      </div>
      <div className="modal-actions" style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
        <button 
          className="submit-btn" 
          style={{ background: '#333', border: '1px solid #444', flex: 1 }}
          onClick={() => setShowDeleteModal(false)}
        >
          Keep It
        </button>
        <button 
          className="submit-btn" 
          style={{ background: 'rgba(239, 68, 68, 0.2)', border: '1px solid #ef4444', color: '#ef4444', flex: 1 }}
          onClick={confirmDeletion}
        >
          Delete All
        </button>
      </div>
    </div>
  </div>
)}<style>{`
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
  }

  .neon-modal {
    background: #0a0a0a;
    border: 1px solid #ef4444;
    box-shadow: 0 0 20px rgba(239, 68, 68, 0.3);
    border-radius: 16px;
    padding: 30px;
    max-width: 400px;
    width: 90%;
    animation: modalSlideUp 0.3s ease-out;
  }

  @keyframes modalSlideUp {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }

  .modal-header h2 {
    font-size: 1.5rem;
    text-shadow: 0 0 10px rgba(239, 68, 68, 0.5);
  }
`}</style>
      
    </div>
  );
}

export default Main;
